import { ConnectorSyncStatus } from "../../../services/spreadsheet-connector.service";

interface ConnectorStatusBadgeProps {
  status: ConnectorSyncStatus;
}

const statusConfig: Record<ConnectorSyncStatus, { label: string; classes: string }> = {
  [ConnectorSyncStatus.ACTIVE]: { label: "Active", classes: "bg-green-100 text-green-700" },
  [ConnectorSyncStatus.PAUSED]: { label: "Paused", classes: "bg-yellow-100 text-yellow-700" },
  [ConnectorSyncStatus.ERROR]:  { label: "Error",  classes: "bg-red-100 text-red-700" },
};

export default function ConnectorStatusBadge({ status }: ConnectorStatusBadgeProps) {
  const config = statusConfig[status] ?? { label: status, classes: "bg-gray-100 text-gray-600" };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.classes}`}>
      {config.label}
    </span>
  );
}
